<template>
  <v-content class="grey lighten-4">
    <AppBar title="Översikt">
      <v-btn tile icon @click="refresh" :loading="$apollo.loading">
        <v-icon dark>mdi-refresh</v-icon>
      </v-btn>
    </AppBar>
    <AppNavigationDrawer />

    <v-container class="px-0">
      <transition name="scroll-y-transition" mode="out-in">
        <div
          :key="$apollo.loading"
          v-if="$apollo.loading"
          class="d-flex flex-column align-center pt-12"
        >
          <v-progress-circular size="56" indeterminate color="primary" />
          <span class="mt-4 grey--text text--darken-1"
            >Hämtar aktiva bussar</span
          >
        </div>
        <div v-else-if="Object.keys(groupedActiveBuses).length">
          <OverviewListGroup
            :title="orderStatusKind[status]"
            v-for="(group, status) in groupedActiveBuses"
            :key="status"
          >
            <OverviewListItem
              @click="openTrip(activeBus.trip_uuid)"
              v-for="(activeBus, $i) in group"
              :bus="activeBus"
              :key="$i"
            >
              <v-btn icon v-if="activeBus.trip_uuid"
                ><v-icon>mdi-map-search</v-icon></v-btn
              >
            </OverviewListItem>
          </OverviewListGroup>
        </div>
        <div v-else class="d-flex flex-column align-center pt-12">
          <v-icon size="50">mdi-information-outline</v-icon>
          <span class="grey--text text--darken-1"
            >Inga aktiva bussar hittades</span
          >
        </div>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import OverviewListGroup from '@/components/OverviewListGroup'
import OverviewListItem from '@/components/OverviewListItem'
import gql from 'graphql-tag'

const orderStatusKind = {
  Ongoing: 'Pågående',
  Assigned: 'Påbörjade',
  Ordered: 'Ej påbörjade'
}

export default {
  name: 'Overview',

  components: {
    AppBar,
    AppNavigationDrawer,
    OverviewListItem,
    OverviewListGroup
  },

  data: () => ({
    orderStatusKind
  }),

  apollo: {
    activeBuses: {
      query: gql`
        query getActiveBuses($districtId: Int) {
          activeBuses(districtId: $districtId) {
            from
            to
            via
            trip_uuid
            train
            type
            status
          }
        }
      `,
      variables() {
        return {
          districtId: this.$store.get('sso/districtId')
        }
      }
    }
  },

  computed: {
    groupedActiveBuses() {
      const activeBuses = this.activeBuses || []
      const busStatuses = [...new Set(activeBuses.map(x => x.status))]
      const statuses = Object.keys(orderStatusKind).filter(x =>
        busStatuses.includes(x)
      )

      return statuses.reduce((acc, status) => {
        acc[status] = activeBuses.filter(x => x.status === status)
        return acc
      }, {})
    }
  },

  methods: {
    refresh() {
      this.$apollo.queries.activeBuses.refetch()
    },

    openTrip(trip_uuid) {
      if (!trip_uuid) return
      this.$router.push(`/map-view/${trip_uuid}`)
    }
  }
}
</script>
